import React, { useState } from "react";
import { PageLogo } from "../logo/PageLogo";
import { AnchorLink } from "gatsby-plugin-anchor-links";
import { Translate } from "@comps/shared/Translate";
import { usePageContext } from "@/contexts/Page";
import { FooterForm } from "./FooterForm";
import { FooterFormMailchimp } from "./FooterFormMailchimp";
import { useStaticQuery, graphql, Link } from "gatsby";

// component styles
import "./index.scss";
import { useLayout } from "@/hooks/Layout";

export const Footer: React.FC<FooterProps> = ({ content }) => {
  const data = useStaticQuery(graphql`
    query FooterQuery {
      wpLaMarOptions(slug: {eq: "gift-card-options"}) {
        footerGiftCard {
          giftCards {
            giftCardLink
            location
          }
        }
      }
    }
  `);

  const { locations } = useLayout();
  const { slug, language } = usePageContext();

  let redirections;
  const currentLocation = locations.find((location) => location.slug === slug);
  redirections = currentLocation ? currentLocation.socialRedirections : [];
  const generateLink = (path: string) => {
    return language === "es" ? path : `/en${path}`;
  };

  const laCarta = currentLocation ? currentLocation.section02 : null;
  const laCartaLink = laCarta && slug === "peru" ? laCarta.menuList[0].redirection : '';

  const [isOpenGiftCard, setIsOpenGiftCard] = useState(false);

  interface GiftCard {
    location: string;
    giftCardLink: string;
  }
  return (
    <>
      <footer id="page-footer">
        <AnchorLink title="" className="button-go-up" to="#page-wrapper">
          <span className="icon-element"></span>
        </AnchorLink>

        <div className="container-fluid">
          <div className="top">
            <PageLogo color="white" />
            {redirections && redirections.length > 0 ? (
              <ul className="icon-container">
                {redirections.map((redirection, index) => (
                  <li className="element" key={index}>
                    <img
                      className="element__image"
                      src={redirection.icon.node.publicUrl}
                      alt={`${redirection.name} logo`}
                    />
                    <a
                      className="element__redirection redirection-button"
                      rel="noopener noreferrer"
                      href={redirection.link}
                      target="_blank"
                    ></a>
                  </li>
                ))}
              </ul>
            ) : (
              <div className="section__separator color__white mobile-hidden"></div>
            )}
          </div>
          <div className="middle-section">
            <div
              className={`in-order-elements ${slug === "peru" ? "styled" : ""}`}
            >
              {slug === "peru" ? <FooterForm /> : <></>}
              {slug === "san-francisco" || slug === "bellevue" ? <FooterFormMailchimp slug={slug} /> : <></>}
              <div className="links-section">
                <div className="content">
                  {slug === "peru" ? (
                    <>
                      <p className="title">Sobre la mar</p>
                      <ul>
                        <li>
                          <a
                            href={laCartaLink ? laCartaLink : ""}
                            className="element__redirection redirection-button"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            La Carta
                          </a>
                        </li>
                        <li>
                          <Link
                            className="element__redirection redirection-button"
                            to="/peru/events"
                          >
                            Eventos
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="element__redirection redirection-button"
                            to="/peru/giftcards"
                          >
                            Gift Cards
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="element__redirection redirection-button"
                            to="/peru/work-with-us"
                          >
                            Trabaja con nosotros
                          </Link>
                        </li>
                      </ul>
                    </>
                  ) : (
                    <>
                      <p className="title">
                        <Translate id="brand" />
                      </p>
                      <ul>
                        <li>
                          <Link
                            className="element__redirection redirection-button"
                            to={generateLink("/reservations")}
                          >
                            <Translate id="reservations" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="element__redirection redirection-button"
                            to={generateLink("/locations")}
                          >
                            <Translate id="locations" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="element__redirection redirection-button"
                            to={generateLink("/about")}
                          >
                            <Translate id="about" />
                          </Link>
                        </li>
                        <li>
                          <Link
                            className="element__redirection redirection-button"
                            to={generateLink("/news")}
                          >
                            <Translate id="news" />
                          </Link>
                        </li>
                        <li className="dropdown-options">
                          <div 
                            className="dropdown-title"
                            onMouseEnter={() => setIsOpenGiftCard(true)}
                            onMouseLeave={() => setIsOpenGiftCard(false)}
                          >
                            Gift Card Balance
                          </div>
                          <ul 
                            className={`dropdown-list ${
                              isOpenGiftCard
                                ? "show"
                                : "hidden"
                            }`}
                            onMouseEnter={() => setIsOpenGiftCard(true)}
                            onMouseLeave={() => setIsOpenGiftCard(false)}
                          >
                            {
                              data.wpLaMarOptions.footerGiftCard.giftCards?.map((item:GiftCard, index:number) =>
                                <li key={index}>
                                  <a
                                    href={item.giftCardLink}
                                    className="element__redirection redirection-button"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    {item.location}
                                  </a>
                                </li>
                              )
                            }
                          </ul>                          
                        </li>
                      </ul>
                    </>
                  )}
                </div>
              </div>
              <div className="links-section">
                <div className="content">
                  {slug === "peru" ? (
                    <>
                      <p className="title">Ayuda y legales</p>
                      <ul>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://lamarcebicheria.com/legales/Politica-de-uso-de-cookies-LA-MAR.pdf"
                            target="_blank"
                          >
                            Políticas de cookies
                          </a>
                        </li>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://lamarcebicheria.com/legales/Politicas_de_Privacidad_AR_corporativo.pdf"
                            target="_blank"
                          >
                            Política de privacidad
                          </a>
                        </li>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://lamarcebicheria.com/legales/Politica-de-Videovigilancia-lm.pdf"
                            target="_blank"
                          >
                            Políticas de videovigilancia
                          </a>
                        </li>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://lamarcebicheria.com/legales/Terminos-y-condiciones-de-uso-La-Mar.pdf"
                            target="_blank"
                          >
                            Términos y condiciones de uso
                          </a>
                        </li>
                      </ul>
                    </>
                  ) : (
                    <>
                      <p className="title">
                        <Translate id="help" />
                      </p>
                      <ul>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://www.linkedin.com/company/acurio-international/"
                            target="_blank"
                          >
                            <Translate id="job_positions" />
                          </a>
                        </li>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://acuriointernational.com/terms-of-use/"
                            target="_blank"
                          >
                            <Translate id="terms_conditions" />
                          </a>
                        </li>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://acuriointernational.com/privacy-policy/"
                            target="_blank"
                          >
                            <Translate id="privacy_policy" />
                          </a>
                        </li>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://acuriointernational.com/privacy-policy/#california-residents"
                            target="_blank"
                          >
                            <Translate id="california_residents" />
                          </a>
                        </li>
                        <li>
                          <a
                            className="element__redirection redirection-button"
                            rel="noopener noreferrer"
                            href="https://acuriointernational.com/privacy-policy/#gdpr"
                            target="_blank"
                          >
                            <Translate id="uk_residents" />
                          </a>
                        </li>
                      </ul>
                    </>
                  )}
                </div>
              </div>
              <div className="links-section libro-reclamaciones">
                {slug === "peru" ? (
                  <div className="icon-container column">
                    <a
                      title="Redirección a: Libro de reclamaciones Acurios restaurantes"
                      className="title"
                      href="https://reclamaciones.acuriorestaurantes.net/libro_reclamaciones/(S(iqus2pr5xifcxvdgebgkbxad))/libro_reclamaciones.aspx"
                      target="__blank"
                    >
                      <div className="element-container">
                        <span className="icon libro-reclamaciones"></span>
                      </div>
                    </a>
                  </div>
                ) : (
                  <></>
                )}
              </div>
            </div>
          </div>
          {slug === "peru" ? (
            <div className="bottom">
              <span className="bottom__info">
                © {new Date().getFullYear()} <Translate id="copyright" />
              </span>
              <span className="bottom__info">
                RUC: 20509076945 - CINCO MILLAS SAC
              </span>
            </div>
          ) : (
            <div className="bottom">
              <span className="bottom__info"></span>
              <span className="bottom__info">
                © {new Date().getFullYear()} <Translate id="copyright" />
              </span>
            </div>
          )}
        </div>
      </footer>
    </>
  );
}; 